import axios from 'axios';
import { AsYouType } from 'libphonenumber-js'
import store from '../store/store'

const setPortausContextCookie = (portausCompanyId, vm) => {
  vm.$cookies.set('portaus-context-company',portausCompanyId, Infinity, '', '', true);
}

export default {
  changePortausContext (portausContextToken, portausCompanyId, vm) {
      setPortausContextCookie(portausCompanyId, vm);
      localStorage.setItem('portaus-context', portausContextToken);
      axios.defaults.headers.common['X-Portaus-Context'] = portausContextToken;
      store.dispatch('inventory/invalidateInventories');
      store.dispatch('inventory/fetchInventories');
  },
  getFormattedUnit_i18n(product_unit){
    if(product_unit==1){
      return "products.units.box";
    }else if(product_unit==2){
      return "products.units.unitary";
    }
  },
  getFormattedPhoneNumber(phone, format='CA'){
    if(phone==null || phone=='')return '';
    if(phone.length<=4){
      return phone;
    }
    return new AsYouType(format).input(phone);
  },
  formatAmount(amount, locale = 'fr', currency = 'CAD') {
    if (_.upperCase(locale) === 'FR') {
      return (new Intl.NumberFormat('fr-CA', { style: 'currency', currency}).format(amount));
    } else {
      return (new Intl.NumberFormat('en-CA', { style: 'currency', currency}).format(amount))
    }
  },
  formatNumber(number, locale = 'fr') {
    if (_.upperCase(locale) === 'FR') {
      return (new Intl.NumberFormat('fr-CA').format(number));
    } else {
      return (new Intl.NumberFormat('en-CA').format(number))
    }
  }
}
